import { type ReactNode } from 'react';

export function renderInlineMarkdown(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  const regex = /(\*\*(.+?)\*\*|\*(.+?)\*|__(.+?)__|_(.+?)_)/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[2] || match[4]) {
      parts.push(<strong key={key++} className="font-medium">{match[2] || match[4]}</strong>);
    } else if (match[3] || match[5]) {
      parts.push(<em key={key++} className="italic">{match[3] || match[5]}</em>);
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}

export function renderMarkdownParagraphs(text: string, baseClass?: string): ReactNode[] {
  const blocks = text.split('\n\n');
  const elements: ReactNode[] = [];

  for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i].trim();
    if (!block) continue;

    if (block === '---' || block === '***' || block === '___') {
      elements.push(<hr key={i} className="my-6 border-border" />);
      continue;
    }

    const listLines = block.split('\n').filter((l) => /^[-*]\s/.test(l));
    if (listLines.length > 0 && listLines.length === block.split('\n').length) {
      elements.push(
        <ul key={i} className={`list-disc pl-5 space-y-1 ${i > 0 ? (baseClass ?? 'mt-4') : ''}`}>
          {listLines.map((line, j) => (
            <li key={j}>{renderInlineMarkdown(line.replace(/^[-*]\s+/, ''))}</li>
          ))}
        </ul>,
      );
      continue;
    }

    const lines = block.split('\n');
    elements.push(
      <p key={i} className={i > 0 ? (baseClass ?? 'mt-4') : undefined}>
        {lines.map((line, j) => (
          j > 0
            ? <span key={j}><br />{renderInlineMarkdown(line)}</span>
            : <span key={j}>{renderInlineMarkdown(line)}</span>
        ))}
      </p>,
    );
  }

  return elements;
}
